import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading$ = new BehaviorSubject<boolean>(false);

  public get isLoading$(): Observable<boolean> {
    return this._loading$.asObservable();
  }

  public showLoading(): void {
    this._loading$.next(true);
  }
  public hideLoading(): void {
    this._loading$.next(false);
  }
}
